var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": "email-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.658 4.403H2.393c2.06 1 8.782 8.235 9.632 9.033l9.633-9.033m-5.673 7.522l6.848 6.42V5.503"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.026 15.638L9.24 13.025l-6.846 6.422h19.264c-1.304-1.226-4.47-4.195-6.845-6.422l-2.787 2.613zM1.22 5.503v12.842l6.846-6.42"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMTkiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIGFyaWEtbGFiZWxsZWRieT0iZW1haWwtaWNvbiI+PHRpdGxlIGlkPSJlbWFpbC1pY29uIj5FbWFpbCB0byBhIEZyaWVuZDwvdGl0bGU+PGcgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMjEuNjU4IDQuNDAzSDIuMzkzYzIuMDYJXDEJOC43ODIgOC4yMzUgOS42MzIgOS4wMzNsOS42MzMtOS4wMzNNMTUuOTg1IDExLjkyNWw2Ljg0OCA2LjQyVjUuNTAzIj48L3BhdGg+PHBhdGggZD0iTTEyLjAyNiAxNS42MzhMOS4yNCAxMy4wMjVsLTYuODQ2IDYuNDIyaDE5LjI2NGMtMS4zMDQtMS4yMjYtNC40Ny00LjE5NS02Ljg0NS02LjQyMmwtMi43ODcgMi42MTN6TTEuMjIgNS41MDN2MTIuODQybDYuODQ2LTYuNDIiPjwvcGF0aD48L2c+Cgk8L3N2Zz4K";
export { SvgMail as ReactComponent };